import { getValueByPath } from "store/core";

const objectIdRegex = /^[0-9a-fA-F]{24}$/;

export const isObjectIdString = (value) =>
  typeof value === "string" && objectIdRegex.test(value);

export const getRefId = (item) => {
  if (!item) {
    return item;
  }

  if (typeof item === "string") {
    return item;
  }

  return item.id || item._id || item.value || item;
};

export const refsToIds = (items) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.map(getRefId).filter(Boolean);
};

export const getTaxonomyLabel = (item) => {
  if (!item) {
    return "";
  }

  if (typeof item === "string") {
    return isObjectIdString(item) ? "" : item;
  }

  const labelFields = [
    "label",
    "translations.fa.title",
    "translations.title",
    "translations.en.title",
    "title",
    "name",
  ];

  for (const field of labelFields) {
    const value = getValueByPath(item, field);
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }

  return "";
};

export const joinTaxonomyLabels = (items) => {
  if (!Array.isArray(items)) {
    return "";
  }

  return items.map(getTaxonomyLabel).filter(Boolean).join(" - ");
};
